import { render, staticRenderFns } from "./PortalDesignerOptionsBar.vue?vue&type=template&id=27e729f4&"
import script from "./PortalDesignerOptionsBar.vue?vue&type=script&lang=js&"
export * from "./PortalDesignerOptionsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27e729f4')) {
      api.createRecord('27e729f4', component.options)
    } else {
      api.reload('27e729f4', component.options)
    }
    module.hot.accept("./PortalDesignerOptionsBar.vue?vue&type=template&id=27e729f4&", function () {
      api.rerender('27e729f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pageDesigner/PortalDesignerOptionsBar.vue"
export default component.exports